import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  EventEmitter,
  input,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIf, NgTemplateOutlet } from '@angular/common';

import { MarketingCategoryModel } from '@common/marketing-category/marketing-category.model';
import { ProductMeta } from '@proto/store/api/common/common';
import { Urls } from '@helper/urls';
import { WindowDetectService } from '@service/window-detect.service';
import { Constants } from '@helper/constants';

@Component({
  selector: 'app-universal-link',
  templateUrl: './universal-link.component.html',
  imports: [RouterLink, NgIf, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UniversalLinkComponent {
  readonly queryParam = computed(() => {
    let params = this.windowService.isMobileDevice() ? Urls.metaToParam(this.meta()) : undefined;
    const target = this.url();
    if (!target || target?.startsWith('http')) {
      return params;
    }
    const url = new URL(`${Constants.LINK_URL_HOST}${target}`);
    if (url.search) {
      params = params || {};
      for (const [key, value] of url.searchParams) {
        params[key] = value;
      }
      return params;
    }
    return params;
  });
  readonly path = computed(() => {
    const target = this.url();
    if (!target) {
      return '';
    }
    if (target?.startsWith('http')) {
      return target;
    }
    return new URL(`${Constants.LINK_URL_HOST}${target}`).pathname;
  });

  @Output() readonly linkClicked = new EventEmitter<void>();

  @Input() openNewWindow = false;
  @Input() content?: TemplateRef<any>;

  url = input.required<string | null>();
  meta = input<ProductMeta | undefined>();

  constructor(
    private categoryViewModel: MarketingCategoryModel,
    private windowService: WindowDetectService,
    private hostElement: ElementRef
  ) {
    this.hostElement.nativeElement.style.lineHeight = '0';
  }

  beforeNavigation(event: MouseEvent): void {
    if (event.ctrlKey || event.metaKey || event.shiftKey) {
      return;
    }
    if (this.meta) {
      this.categoryViewModel.currentBigId.set(this.meta()?.big?.nameEn ?? '');
    }
    setTimeout(() => this.onLinkClick(event), 0);
  }

  onLinkClick(event: MouseEvent): void {
    if (event.ctrlKey || event.metaKey || event.shiftKey) {
      return;
    }
    this.linkClicked.emit();
  }
}
